module.exports = __webpack_public_path__ + "static/media/product-sweaters.d23d1bb3.jpg";